export const spinnerStyleObj = {
    width: '5rem',
    height: '5rem',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
};